module.exports = __webpack_public_path__ + "static/img/Nav-Tile-template-Rabbit-Vibrators-2.9ac46e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fenlei/Nav-Tile-template-Rabbit-Vibrators-2.jpg
// module id = Q3Ys
// module chunks = 0